import {metadaApi} from '@dms/api/base';

import {
  GetServiceCaseTypeApiArg,
  GetServiceCaseTypeApiResponse,
  PatchServiceCaseTypeApiArg,
  PatchServiceCaseTypeApiResponse,
  PostServiceCaseTypeApiArg,
  PostServiceCaseTypeApiResponse,
  PatchServiceCaseTypeSetAsActiveApiResponse,
  PatchServiceCaseTypeSetAsActiveApiArg,
  PatchServiceCaseTypeSetAsInactiveApiResponse,
  PatchServiceCaseTypeSetAsInactiveApiArg,
  PostServiceCaseTypeApiResponseSchema,
  PostServiceCaseTypeApiArgSchema,
  GetServiceCaseTypeApiResponseSchema,
  GetServiceCaseTypeApiArgSchema,
  PatchServiceCaseTypeApiArgSchema,
  PatchServiceCaseTypeApiResponseSchema,
  PatchServiceCaseTypeSetAsActiveApiResponseSchema,
  PatchServiceCaseTypeSetAsActiveApiArgSchema,
  PatchServiceCaseTypeSetAsInactiveApiResponseSchema,
  PatchServiceCaseTypeSetAsInactiveApiArgSchema,
  GetServiceCaseTypesApiResponseSchema,
  GetServiceCaseTypesApiResponse,
  GetServiceCaseTypesApiArg,
  GetServiceCaseTypesApiArgSchema,
  DeleteServiceCaseTypeApiResponse,
  DeleteServiceCaseTypeApiArg,
  DeleteServiceCaseTypeApiResponseSchema,
  DeleteServiceCaseTypeApiArgSchema,
} from './types';

export const metadaWorkshopServiceCaseTypeApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postServiceCaseType: build.mutation<PostServiceCaseTypeApiResponse, PostServiceCaseTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v2/service-case-type`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['serviceCaseTypes'],
      extraOptions: {
        responseSchema: PostServiceCaseTypeApiResponseSchema,
        requestSchema: PostServiceCaseTypeApiArgSchema,
      },
    }),
    getServiceCaseType: build.query<GetServiceCaseTypeApiResponse, GetServiceCaseTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v2/service-case-type/${queryArg.serviceCaseTypeId}`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceCaseType', id: queryArg.serviceCaseTypeId},
      ],
      extraOptions: {
        responseSchema: GetServiceCaseTypeApiResponseSchema,
        requestSchema: GetServiceCaseTypeApiArgSchema,
      },
    }),
    patchServiceCaseType: build.mutation<
      PatchServiceCaseTypeApiResponse,
      PatchServiceCaseTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case-type/${queryArg.serviceCaseTypeId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'serviceCaseTypes',
        {type: 'serviceCaseType', id: queryArg.serviceCaseTypeId},
      ],
      extraOptions: {
        responseSchema: PatchServiceCaseTypeApiResponseSchema,
        requestSchema: PatchServiceCaseTypeApiArgSchema,
      },
    }),
    patchServiceCaseTypeSetAsActive: build.mutation<
      PatchServiceCaseTypeSetAsActiveApiResponse,
      PatchServiceCaseTypeSetAsActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case-type/${queryArg.serviceCaseTypeId}/set-as-active`,
        method: 'PATCH',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'serviceCaseTypes',
        {type: 'serviceCaseType', id: queryArg.serviceCaseTypeId},
      ],
      extraOptions: {
        responseSchema: PatchServiceCaseTypeSetAsActiveApiResponseSchema,
        requestSchema: PatchServiceCaseTypeSetAsActiveApiArgSchema,
      },
    }),
    patchServiceCaseTypeSetAsInactive: build.mutation<
      PatchServiceCaseTypeSetAsInactiveApiResponse,
      PatchServiceCaseTypeSetAsInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case-type/${queryArg.serviceCaseTypeId}/set-as-inactive`,
        method: 'PATCH',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'serviceCaseTypes',
        {type: 'serviceCaseType', id: queryArg.serviceCaseTypeId},
      ],
      extraOptions: {
        responseSchema: PatchServiceCaseTypeSetAsInactiveApiResponseSchema,
        requestSchema: PatchServiceCaseTypeSetAsInactiveApiArgSchema,
      },
    }),
    getServiceCaseTypes: build.query<GetServiceCaseTypesApiResponse, GetServiceCaseTypesApiArg>({
      query: () => ({
        url: `/service/v1/service-case-types`,
      }),
      providesTags: ['serviceCaseTypes'],
      extraOptions: {
        responseSchema: GetServiceCaseTypesApiResponseSchema,
        requestSchema: GetServiceCaseTypesApiArgSchema,
      },
    }),
    deleteServiceCaseType: build.mutation<
      DeleteServiceCaseTypeApiResponse,
      DeleteServiceCaseTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case-type/${queryArg.serviceCaseTypeId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: ['serviceCaseTypes'],
      extraOptions: {
        responseSchema: DeleteServiceCaseTypeApiResponseSchema,
        requestSchema: DeleteServiceCaseTypeApiArgSchema,
      },
    }),
  }),
});

export const {
  usePostServiceCaseTypeMutation,
  useGetServiceCaseTypeQuery,
  usePatchServiceCaseTypeMutation,
  usePatchServiceCaseTypeSetAsActiveMutation,
  usePatchServiceCaseTypeSetAsInactiveMutation,
  useGetServiceCaseTypesQuery,
  useDeleteServiceCaseTypeMutation,
} = metadaWorkshopServiceCaseTypeApi;
